import React, { useState } from "react";
import { Box, Tab } from "@mui/material";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { styled } from "@mui/material/styles";

import SegmentCountByAirline from "./SegmentCountByAirline";
import SegmentCountBySector from "./SegmentCountBySector";
import SegmentCountByGds from "./SegmentCountByGds";
import SegmentCountByAgent from "./SegmentCountByAgent";
import SegmentCountByVendor from "./SegmentCountByVendor";
import SegmentCountByCustomer from "./SegmentCountByCustomer";

const CustomTab = styled(Tab)(({ theme, active }) => ({
  flexBasis: "16.1%",
  backgroundColor: active ? "#6E6996" : "#B4B4CD",
  color: active ? "#FFFFFF !important" : "#FFFFFF",
  minHeight: "30px",
  borderRadius: "10px",
  fontFamily: "Outfit",
  fontSize: "13px",
  textTransform: "none",
  fontWeight: 400,
  margin: "0 4px",
}));

const SegmentCount = () => {
  const WHITE_LEVEL = process.env.REACT_APP_WHITE_LEVEL === "true";

  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ marginTop: { xs: "20px", sm: "0", md: "0" } }}>
      <TabContext value={value}>
        <Box
          mb={1}
          sx={{
            overflowX: { xs: "auto", sm: "hidden" }, // Enable scrolling for xs
            whiteSpace: { xs: "nowrap", sm: "normal" }, // Prevent wrapping for xs
            width: "100%", // Ensure the container takes full width
          }}
        >
          <TabList
            onChange={handleChange}
            aria-label="customized tabs"
            sx={{
              display: "flex",
              justifyContent: { xs: "flex-start", sm: "space-between" }, // Stretch tabs for large devices
              width: { xs: "max-content", sm: "100%" }, // Allow scrolling on xs, full width for larger devices
            }}
            TabIndicatorProps={{ style: { display: "none" } }}
          >
            {[
              "Airline",
              "Sector",
              `${WHITE_LEVEL ? "Consolidator" : "GDS"}`,
              "Agent",
              "Booking Vendor",
              "Customer",
            ].map((label, index) => (
              <CustomTab
                key={label}
                label={label}
                value={(index + 1).toString()}
                active={value === (index + 1).toString()}
              />
            ))}
          </TabList>
        </Box>

        <TabPanel value="1" style={{ padding: "15px 0px" }}>
          <SegmentCountByAirline />
        </TabPanel>
        <TabPanel value="2" style={{ padding: "15px 0px" }}>
          <SegmentCountBySector />
        </TabPanel>
        <TabPanel value="3" style={{ padding: "15px 0px" }}>
          <SegmentCountByGds />
        </TabPanel>
        <TabPanel value="4" style={{ padding: "15px 0px" }}>
          <SegmentCountByAgent />
        </TabPanel>
        <TabPanel value="5" style={{ padding: "15px 0px" }}>
          <SegmentCountByVendor />
        </TabPanel>
        <TabPanel value="6" style={{ padding: "15px 0px" }}>
          <SegmentCountByCustomer />
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default SegmentCount;
